import React from 'react';
import Card from '@applied/dragonfruit/src/components/Card/Card';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import ConditionalLink from '@applied/dragonfruit/src/components/Link/ConditionalLink';
import LoadingSkeleton from '@applied/dragonfruit/src/components/LoadingSkeleton/LoadingSkeleton';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';
import { checkExists } from 'api/typing';
import classNames from 'classnames';

import { Divider } from 'components/common/Divider/Divider';
import { TeamMemberSummary } from 'components/WebOfferPage/RoleSection/TeamMemberSummary/TeamMemberSummary';
import { TeamSection } from 'components/WebOfferPage/RoleSection/TeamSection/TeamSection';
import { useWebOffer } from 'components/WebOfferPage/web_offer_context';

import './role-section.scss';

export function RoleSection(): JSX.Element {
  const {
    manager,
    teamMembers,
    jobInfo: { jobTitle, teamName, teamPageUrl, atsJobPostUrl },
  } = useWebOffer();

  const managerSummary = <TeamMemberSummary employee={manager} />;
  const teamSummaries = teamMembers
    .filter((member) => checkExists(member.resourceUuid))
    .map((member) => <TeamMemberSummary key={member.resourceUuid} employee={member} />);

  const roleDescription =
    jobTitle && teamName ? (
      <Typography className="role-description" variant="header">
        The{' '}
        <span className={classNames('text-style-header', 'role-highlight')}>
          <ConditionalLink link={teamPageUrl ?? undefined}>{teamName}</ConditionalLink>
        </span>{' '}
        team is excited to welcome you as a{' '}
        <span className={classNames('text-style-header', 'role-highlight')}>
          <ConditionalLink link={atsJobPostUrl ?? undefined}>{jobTitle}</ConditionalLink>
        </span>
      </Typography>
    ) : (
      <LoadingSkeleton width="450px" height="56px" />
    );

  return (
    <Flex className="role-section" direction="column" justify="center" padding="xxl">
      <div id="role">
        <Flex className="role-section-header" direction="column">
          <Typography className="role-label" variant="title">
            ROLE
          </Typography>
          {roleDescription}
        </Flex>
        <Flex alignment="center" justify="center">
          <Card
            className="role-card"
            direction="row"
            gap="xl"
            padding="xl"
            alignment="center"
            justify="space-between"
          >
            <TeamSection title="Manager">{managerSummary}</TeamSection>
            <Divider orientation="vertical" />
            <TeamSection title="Team">{teamSummaries}</TeamSection>
          </Card>
        </Flex>
      </div>
    </Flex>
  );
}
